import { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  BASE_PROOF_OF_COVERAGE_PATH,
  PROOF_OF_COVERAGE_ROUTES,
} from "@routing/Residents/ProofOfCoverage";
import useAppSelector from "@redux/hooks/useAppSelector";
import {
  resetExternalCoverageData,
  resetPolicyTypeForm,
  selectAddedCoverageDetails,
  selectCtPolicyLocator,
  selectProofOfCoverageDetails,
} from "@redux/coverages/coveragesSlice";
import { COVERAGE_DATA_ROUTES } from "@routing/Residents/ProofOfCoverage/CoverageData";
import useAppDispatch from "@redux/hooks/useAppDispatch";

export const useResetFlowOnMissingData = (onClosePath: string) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const coverage = useAppSelector(selectProofOfCoverageDetails);
  const ctPolicyLocator = useAppSelector(selectCtPolicyLocator);
  const addedCoverageUpdatedResidentDetails = useAppSelector(
    selectAddedCoverageDetails
  )?.updatedResident;

  const resetData = useCallback(() => {
    dispatch(resetExternalCoverageData());
    dispatch(resetPolicyTypeForm());
    navigate(
      `${onClosePath}/${BASE_PROOF_OF_COVERAGE_PATH}/${PROOF_OF_COVERAGE_ROUTES.POLICY_TYPE}?${searchParams.toString()}`
    );
  }, [dispatch, navigate]);

  const routesRequiringCoverage = useMemo(
    () => [
      PROOF_OF_COVERAGE_ROUTES.COVERAGE_DOCUMENTS,
      COVERAGE_DATA_ROUTES.COVERAGE_DETAILS,
    ],
    []
  );

  const routesRequiringCtPolicyLocator = useMemo(
    () => [
      COVERAGE_DATA_ROUTES.POLICY_ALREADY_ADDED,
      COVERAGE_DATA_ROUTES.POLICY_NOT_FOUND,
    ],
    []
  );

  const routesRequireingAddedCoverageDetails = useMemo(
    () => [
      PROOF_OF_COVERAGE_ROUTES.COVERAGE_ADDED,
      PROOF_OF_COVERAGE_ROUTES.ACTIVE_TLL_FOUND,
      PROOF_OF_COVERAGE_ROUTES.SCHEDULED_TLL_FOUND,
    ],
    []
  );

  useEffect(() => {
    if (
      (!coverage &&
        routesRequiringCoverage.some((route) =>
          location.pathname.includes(route)
        )) ||
      (!ctPolicyLocator &&
        routesRequiringCtPolicyLocator.some((route) =>
          location.pathname.includes(route)
        )) ||
      (!addedCoverageUpdatedResidentDetails &&
        routesRequireingAddedCoverageDetails.some((route) =>
          location.pathname.includes(route)
        ))
    ) {
      resetData();
    }
  }, [
    location.pathname,
    resetData,
    coverage,
    ctPolicyLocator,
    addedCoverageUpdatedResidentDetails,
  ]);
};
